import React from 'react';
import { Textarea } from '../../../components/ui/textarea';

const Notes: React.FC = () => {
    return (
        <div className="bg-gray-200 rounded-xl p-4 h-2/3 overflow-auto">
            <h3 className="text-lg font-semibold text-maxi-text-dark">
                Notas
            </h3>
            <div>
                <p className="text-maxi-text font-medium mb-2 text-sm">Nota</p>
                <Textarea
                    defaultValue="Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum"
                    className="min-h-[120px] text-xs resize-none"
                    placeholder="Agregar nota..."
                />
            </div>
        </div>
    );
};

export default Notes;